import { formatInTimeZone } from "date-fns-tz";
import React from "react";

import { type Money, formatMoneyCompact, moneyFromWire, zeroMoney } from "@performyard/money";
import { ButtonStandard, Link, Text } from "@performyard/py-components";

import { useCompanySettings } from "../../../../api/hooks";
import { useCompensationSettings } from "../../../../api/hooks";

/*
leaving in for follow on implementation ticket to show integration type PY-11774 (expected ticket)
const INTEGRATION_IMAGE_BASE = "/static/img/Integrations/";

const integrationMap: Record<string, string> = {
	"ukg-pro": `${INTEGRATION_IMAGE_BASE}ukgpro.png`,
	"adp-wfn": `${INTEGRATION_IMAGE_BASE}ADP.png`,
	"adp-vantage": `${INTEGRATION_IMAGE_BASE}ADP.png`,
	bamboohr: `${INTEGRATION_IMAGE_BASE}bamboohr-logo.png`,
	rippling: `${INTEGRATION_IMAGE_BASE}rippling-icon.png`,
	gusto: `${INTEGRATION_IMAGE_BASE}gusto-icon-orange.png`,
	netchex: `${INTEGRATION_IMAGE_BASE}netchex.png`,
};
*/

/**
 * Abbreviated total-salary display.
 *
 * Was a third hand-rolled copy of this logic (after the two `Widget.tsx` files), with
 * its own `/= 1000` loop and a `Math.round(value)` branch that dropped the cents off a
 * figure labelled "Total Salary". `formatMoneyCompact` is the one implementation, and
 * it supplies the currency symbol itself.
 */
const formatCompensation = (value: Money): string => formatMoneyCompact(value, { trimWholeFractions: true });

const CompensationMetaCard = () => {
	const { data: companySettings } = useCompanySettings();
	const { data: compensationSettings } = useCompensationSettings();

	const salary = moneyFromWire(compensationSettings?.totalSalary) ?? zeroMoney();
	const lastUpdated = compensationSettings?.totalSalaryUpdatedAt
		? new Date(compensationSettings.totalSalaryUpdatedAt)
		: null;
	const timezone = companySettings?.default_timezone || "America/New_York";

	return (
		<div className="rounded-md bg-neutral-1 p-4">
			<div className="mb-4 flex justify-between gap-4">
				<div>
					<Text size="caption" weight="regular" color="neutral-9">
						Total Salary
					</Text>
					<Text size="heading-3" weight="semi-bold" color="neutral-9">
						{formatCompensation(salary)}
					</Text>
				</div>
				<div className="">
					<Link href="/administration/sync-log/">
						<ButtonStandard variant="outline" color="neutral" size="medium">
							View Change Log
						</ButtonStandard>
					</Link>
				</div>
			</div>
			<div className="flex items-center gap-2">
				<Text size="caption" weight="regular" color="neutral-9">
					<span className="font-semibold">Last Updated:</span>{" "}
					{lastUpdated ? formatInTimeZone(lastUpdated, timezone, "MMM d, yyyy h:mmaaa zzz") : "N/A"}
				</Text>
			</div>
		</div>
	);
};

export default CompensationMetaCard;
